module.exports = __webpack_public_path__ + "assets/play-logo-vertical-component.446f88cc.svg";